import { useQuery as e } from "@tanstack/react-query";
import { getTrailerRentalLocationsRequest as r } from "../requests/getLocationsRequest.js";
const o = () => e({
  queryKey: ["trailer-rental-locations"],
  queryFn: async () => await r(),
  enabled: !0,
  retry: !0,
  staleTime: 1 / 0
});
export {
  o as useGetTrailerRentalLocationsQuery
};
